/*
 * fn: fetchCard
 *
 * Given a cardId, sends a request to the Card API endpoint
 *
 */
import { type CardResponseType } from '@/defs/apiLegacy/cardResponse'
import { type CardIdType } from '@/defs/card'
import { parseCardId } from '@/utils/cardUtil'
import { fetchApi } from '@/utils/requestUtil'

import { parseCardResponse } from './parseCardResponse'

export const fetchCard = async (cardId: CardIdType) => {
  const { collectorNumber, set, slug } = parseCardId(cardId)

  const params = new URLSearchParams()
  if (collectorNumber) params.set('collector_number', collectorNumber)
  if (set) params.set('set', set)
  const query = params.toString()

  const response = (
    await fetchApi<CardResponseType>(
      query
        ? { base: 'apiCloudflare', path: `/card/${slug}?${query}` }
        : { base: 'jsonCloudflare', path: `/cards/${slug}` },
    )
  ).data

  return parseCardResponse(response)
}
